import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '@/components/SEO';

export default function NotFoundPage() {
  return (
    <main className="min-h-[72vh] flex items-center bg-radial-blue" data-testid="notfound-page">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404"/>
      <div className="max-w-[920px] mx-auto px-5 lg:px-8 text-center py-24">
        <div className="text-[12.5px] font-semibold uppercase tracking-wider text-bp-blue">Error · 404</div>
        <h1 className="h-display text-[72px] sm:text-[120px] mt-4">
          Page <span className="grad-text">missing.</span>
        </h1>
        <p className="mt-6 text-[17px] text-bp-slate max-w-md mx-auto">
          The page you&rsquo;re looking for either moved, got renamed, or never existed. Let&rsquo;s get you back on track.
        </p>
        <div className="mt-10">
          <Link to="/" className="btn-primary"><ArrowLeft size={14}/> Back to Home</Link>
        </div>
      </div>
    </main>
  );
}
